import React from "react";
import tmdb from '../tmdb.svg';

const Foot = () => {
    const Developers = {
        prashant: "https://prashant.me",
        nischal: "https://github.com/justgoof9"
    };

    return (
        <div className="footer">
        
            <a href="https://www.themoviedb.org" title="The Movie DB Website">
                <img
                    src={tmdb}
                    style={{ width: 100 }}
                    alt="The Movie DB"
                />
            </a>
            <br />
            <br />
            Made with{" "}
            <span className="icon-heart-fill" style={{ color: "red" }} /> in
            Virginia &copy; 2018.
            <br />
            <br />
            Designed and Developed by{" "}
            <a href={Developers.prashant}>Prashant Shrestha</a> &amp;{" "}
            <a href={Developers.nischal}>Nischal Shrestha</a>.
        </div>
    );
};

export default Foot;



// WEBPACK FOOTER //
// ./src/components/Foot.js